export default [
  'errorName',
  'errorMessage',
  '$sce',
  function (errorName, errorMessage, $sce) {
    /* eslint-disable */
    const messages = {
      need_edit_announcement: 'Ваш тариф устарел и не позволяет размещать объявления на сайте, выберите один из новых.',
      access_denied_for_premium_announcements:
        'Возможность размещения Премиум-объявлений для вашего аккаунта заблокирована администрацией.',
      access_denied_for_top3_announcements_by_rules: 'Не выполнены условия необходимые для размещения Топ-объявления.',
      service_used_max_time_in_period:
        'Вы достигли лимита по количеству использования данной услуги в рамках вашего тарифа. Необходимо отредактировать объявление.',
      access_denied_for_publishing_new_announcements:
        'Для пользователя установлен запрет на публикацию любых новых объявлений.',
      incorrect_status_announcement: 'Неверный статус.',
      published_incorrect_status_announcement: 'Некорректный статус для перевода объявления в статус «Опубликовано».',
      repeat_published_for_sold_announcement_possibly_month:
        'Повторная публикация объявления возможна только через месяц.',
      announcement_multy_disabled: 'Возможность размещения и редактирования мультиобъявлений закрыта.',
    };
    /* eslint-enable */

    if (errorMessage) {
      const message = Array.isArray(errorMessage) ? errorMessage.join('<br />') : errorMessage;

      this.message = $sce.trustAsHtml(message);
    } else {
      this.message = messages[errorName];
    }
  },
];
